import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Row, Col } from '@gympass/yoga'

import {
  activisionBlizzard,
  batteriesBulbs,
  citizensBank,
  etsy,
  seatGeek,
  sunPower,
} from '@assets/partners'

import Container from '../../Home.style'
import * as Style from './Companies.style'

export default function Companies() {
  return (
    <Style.Wrapper>
      <Container>
        <Row>
          <Col xxs={12}>
            <Style.Title>
              <FormattedMessage
                id="smb_acquisition_home.featured_customer.title"
                values={{
                  span: (...chunks) => <span>{chunks}</span>,
                }}
              />
            </Style.Title>
          </Col>
        </Row>

        <Row>
          <Col xxs={6} xl={2}>
            <Style.CompaniesLogos src={sunPower} alt="Sun Power" />
          </Col>
          <Col xxs={6} xl={2}>
            <Style.CompaniesLogos src={seatGeek} alt="Seat Geek" />
          </Col>
          <Col xxs={6} xl={2}>
            <Style.CompaniesLogos src={citizensBank} alt="Citizen Bank" />
          </Col>
          <Col xxs={6} xl={2}>
            <Style.CompaniesLogos
              src={activisionBlizzard}
              alt="Activision Blizzard"
            />
          </Col>
          <Col xxs={6} xl={2}>
            <Style.CompaniesLogos src={etsy} alt="Etsy" />
          </Col>
          <Col xxs={6} xl={2}>
            <Style.CompaniesLogos src={batteriesBulbs} alt="Batteries Bulbs" />
          </Col>
        </Row>
      </Container>
    </Style.Wrapper>
  )
}
